{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "Can Anxiety Lower IQ Test Scores?",
  "description": "Anxiety can consume attention or working memory, but effects vary.",
  "category": "IQ questions answered",
  "sections": [
    {
      "heading": "Short answer",
      "paragraphs": ["Anxiety can consume attention or working memory, but effects vary."]
    },
    {
      "heading": "What affects it",
      "paragraphs": [
        "Test quality, age, health, language, education, motivation, environment, and purpose all matter.",
        "An average study effect cannot predict one person exactly."
      ]
    },
    {
      "heading": "Guidance",
      "paragraphs": [
        "Use adequate sleep, quiet conditions, accommodations, and a suitable instrument.",
        "For children, health, disability, or high-stakes decisions, consult a qualified professional."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "Anxiety can consume attention or working memory, but effects vary. Content reviewed 18 July 2026."
}
